import axios from 'axios';
import Constants, { fixProtocol } from '../../../constants/constants';
import { ActivitySummaryResponse, ProgramDetails } from './types';
import { configuration } from './configuration';

export const getDailySummary = async (playerId: number, date: Date): Promise<ProgramDetails[]> => {
  const parsedDate = new Date(date).toISOString().split('T')[0];
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/players/restorative-daily-activity-summary`);

  url.searchParams.append('player_id', `${playerId}`);
  url.searchParams.append('date', `${parsedDate}`);

  return axios
    .get<ActivitySummaryResponse>(url.toString())
    .then((response) => {
      if (response.status === 200) {
        const { programs } = response.data;

        const parsedPrograms = programs.map((program) => {
          const parsedActivities = program.activities.map((activity) => {
            return {
              title: activity.name,
              duration: activity.duration,
            };
          });

          return {
            programId: program.id,
            title: program.name,
            currentTime: program.total_duration,
            activities: parsedActivities || [],
            maxTime: configuration.dailyGoal,
          };
        });

        return parsedPrograms;
      }

      throw Error('Error getting summary info');
    })
    .catch((error) => {
      throw Error('Error getting summary info', error);
    });
};
